import { CustomerModel } from 'src/Routes/CustomerData/CustomerModel'
import { CustomersActionModel } from './CustomersReducer'

export const customers_set = (customers: CustomerModel[]): CustomersActionModel => {
  return { type: 'customers_set', customers: customers }
}
